import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  // Transform
  transform(value: any): any {
    let message = '';
    const splitted = value.split(' ');

    // Form message
    message = splitted[0] + ' ';

    // Hide some numbers
    for (let i = 0; i < splitted[1].length - 5; i++) message += 'x';

    // Add a dash
    message += '-';
    message += splitted[1].slice(splitted[1].length - 4, splitted[1].length);

    // Return value
    return message;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/phone-format/phone-format.pipe.ts